import React from 'react';

import { Card, CardContent, CardFooter, CardHeader, CardTitle } from 'shadcn/components/ui/Card';
import { cn } from 'shadcn/lib/utils';

import { AllocationBreakdownSource } from './AllocationBreakdownSource';

/**
 * @typedef {{ id: number, code: string, displayName: string }} CompanySource
 *
 * @param {Object} props
 * @param {Array<{ companySource: CompanySource, numCases: number }>} props.allocations
 * @param {string} [props.className]
 */
function AllocationBreakdown({ allocations = [], className }) {
    const totalCases = allocations.reduce((sum, allocation) => sum + allocation.numCases, 0);

    return (
        <Card className={cn('gap-4 py-4', className)}>
            <CardHeader className="px-4 pb-0">
                <CardTitle className="text-base">Allocation Breakdown</CardTitle>
            </CardHeader>
            <CardContent className="px-4">
                {allocations.length > 0 ? (
                    <div className="flex flex-wrap justify-center gap-3">
                        {allocations.map((allocation) => (
                            <AllocationBreakdownSource
                                key={allocation.companySource.id}
                                className="w-44"
                                companySource={allocation.companySource}
                                numCases={allocation.numCases}
                            />
                        ))}
                    </div>
                ) : null}
            </CardContent>
            <CardFooter className="px-4 pt-0">
                <p className="text-sm text-muted-foreground">Total: {totalCases} cases</p>
            </CardFooter>
        </Card>
    );
}

export { AllocationBreakdown };
